var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Form, FormArray } from '../module';
import { LIFE_CYCLE_TYPE, } from '../type';
import { clone, devWarning, flatArray, isArr, isFn, isValid, Keys } from '@ecom-zform/shared';
import { buildLazyCallback, DEFAULT_FORM_STATE, generatePathString, getState, internalLog, isRootForm, ROOT_VALUE_PATH, setExtraLog, setStateLog, } from './index';
import AsyncValidator from 'async-validator';
import { getIn, setIn } from './path';
import { watch } from '../watch';
import { computed } from '@vue/reactivity';
var resetFormArrayChildrenAddress = function (form) {
    form.children.forEach(function (fc, i) {
        fc.address.arr.splice(form.address.arr.length, 1, i);
        fc.address.string = generatePathString(fc.address.arr);
    });
    form.children.forEach(function (f, i) {
        f.allChildren.forEach(function (fc) {
            if (fc.address.string.indexOf(form.address.string) === 0 &&
                fc.address.string !== form.address.string) {
                fc.address.arr.splice(form.address.arr.length, 1, i);
                fc.address.string = generatePathString(fc.address.arr);
            }
        });
    });
};
export var spliceArrayChildren = function (form, startIndex, deleteCount) {
    var _a;
    var insertItem = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        insertItem[_i - 3] = arguments[_i];
    }
    var list = [];
    insertItem.forEach(function (state) {
        if (isArr(state.value)) {
            list.push(form.nodeArray(form.children.length));
        }
        else {
            list.push(form.node(form.children.length));
        }
    });
    // 取出添加的节点
    form.children.splice(form.children.length - list.length, list.length);
    // 放置到对应位置
    var deletedChildren = (_a = form.children).splice.apply(_a, __spreadArray([startIndex, deleteCount], __read(list)));
    // 移除被删除节点的 watch 方法
    deletedChildren.forEach(function (form) {
        __spreadArray([form], __read(form.allChildren)).forEach(function (f) { return f.watchStopFunList.forEach(function (stop) { return stop(); }); });
    });
    resetFormArrayChildrenAddress(form);
    return form;
};
export var disposeFromAndToIndex = function (value, from, to) {
    if (from < 0) {
        from = 0;
    }
    else if (from >= value.length) {
        from = value.length - 1;
    }
    if (to < 0) {
        to = 0;
    }
    else if (to >= value.length) {
        to = value.length - 1;
    }
    return { from: from, to: to };
};
export var exchangeArrayChildren = function (form, fromIndex, toIndex) {
    var fromFC = form.children[fromIndex];
    form.children[fromIndex] = form.children[toIndex];
    form.children[toIndex] = fromFC;
    resetFormArrayChildrenAddress(form);
};
export var moveArrayChildren = function (form, fromIndex, toIndex) {
    var _a = __read(form.children.splice(fromIndex, 1), 1), children = _a[0];
    form.children.splice(toIndex, 0, children);
    resetFormArrayChildrenAddress(form);
};
export var getStateWithAllChildren = function (form, stateType) {
    var res = {};
    getFormWithAllChildren(form).forEach(function (fc) {
        // res[fc.address.string] = stateType ? fc[stateType].value : getState(fc);
        res[fc.address.string] = getState(fc, stateType);
    });
    return res;
};
export function buildSetState(form, payload, reason) {
    var newState = clone(isFn(payload) ? payload(form.state) : payload);
    // TODO 设置 errorInfo 时补充 value, field, path
    Keys(newState).forEach(function (stateType) {
        form[stateType].value = newState[stateType];
    });
    setStateLog(form, reason);
    form.publish(LIFE_CYCLE_TYPE.ON_STATE_CHANGE);
    return form;
}
export function buildSetExtra(form, payload, reason) {
    var newState = clone(isFn(payload) ? payload(form.extra) : payload);
    Keys(newState).forEach(function (stateType) {
        form.extraRef.value[stateType] = newState[stateType];
    });
    setExtraLog(form, reason);
    return form;
}
export var getFormWithAllChildren = function (form) { return __spreadArray([form], __read(form.allChildren)); };
export var buildGetAllChildren = function (form) {
    var children;
    if (isArr(form.children)) {
        children = form.children.filter(function (f) { return f; });
    }
    else {
        children = Object.values(form.children).filter(function (f) { return f; });
    }
    return __spreadArray(__spreadArray([], __read(children)), __read(flatArray(children.map(function (f) { return f.allChildren; }))));
};
export var buildGetAllParent = function (form) {
    if (isRootForm(form))
        return [];
    var allParent = [];
    var f = form;
    while (!isRootForm(f)) {
        f = f.parent;
        allParent.push(f);
    }
    return allParent;
};
export var buildNode = function (form, rootForm, path) {
    if (!form.children[path]) {
        form.children[path] = new Form({
            root: rootForm,
            parent: form,
            path: path,
        });
    }
    return form.children[path];
};
export var buildNodeArray = function (form, rootForm, path) {
    if (!form.children[path]) {
        form.children[path] = new FormArray({
            root: rootForm,
            parent: form,
            path: path,
        });
    }
    return form.children[path];
};
export var filterRules = function (form, trigger) {
    var _a;
    if (trigger === undefined) {
        return form.state.rules || [];
    }
    return (((_a = form.state.rules) === null || _a === void 0 ? void 0 : _a.filter(function (rule) {
        if (rule.validateTrigger === undefined) {
            return true;
        }
        var ruleTrigger = Array.isArray(rule.validateTrigger)
            ? rule.validateTrigger
            : [rule.validateTrigger];
        return ruleTrigger.includes(trigger);
    })) || []);
};
var validateRules = function (form, rules) { return __awaiter(void 0, void 0, void 0, function () {
    var value, validator;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                value = form.state.value;
                validator = new AsyncValidator((_a = {},
                    _a[form.field] = rules,
                    _a));
                return [4 /*yield*/, new Promise(function (resolve) {
                        var _a;
                        validator.validate((_a = {}, _a[form.field] = value, _a), function (e) {
                            resolve(e);
                        });
                    })];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}); };
var validateFinished = function (form, errors) {
    var status = errors ? 'error' : 'success';
    var value = form.state.value;
    form.setState(function (state) { return ({
        error: __assign(__assign({}, state.error), { status: status, help: errors ? errors.map(function (_a) {
                var message = _a.message;
                return message || '';
            }) : [], field: "" + form.field, path: form.address.string, value: value }),
    }); }, internalLog('validate update error', form));
    if (status === 'error') {
        form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_FAILED);
    }
    else {
        form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_SUCCESS);
    }
};
export var buildValidate = function (form, trigger) { return __awaiter(void 0, void 0, void 0, function () {
    var rules, value, commonErrorInfo;
    var _a;
    return __generator(this, function (_b) {
        rules = filterRules(form, trigger);
        value = form.state.value;
        commonErrorInfo = {
            field: "" + form.field,
            path: form.address.string,
            value: value,
        };
        if (!isValid(rules) || rules.length === 0 || form.state.disableValidate) {
            // TODO 这里还需要思考一下，不需要校验就重置为 success 吗？是不是应该有别的状态，比如 dirty？
            if (((_a = form.state.error) === null || _a === void 0 ? void 0 : _a.status) === 'error') {
                form.setState({
                    error: __assign({ status: 'success', help: [] }, commonErrorInfo),
                }, internalLog('', form));
            }
            return [2 /*return*/];
        }
        // TODO validating test
        form.setState({ validating: true }, internalLog('set validating -> true', form));
        form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_START);
        return [2 /*return*/, new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
                var errors, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            errors = null;
                            if (!form.state.validateFirst) return [3 /*break*/, 5];
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < rules.length)) return [3 /*break*/, 4];
                            return [4 /*yield*/, validateRules(form, [rules[i]])];
                        case 2:
                            errors = _a.sent();
                            if (errors) {
                                return [3 /*break*/, 4];
                            }
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [3 /*break*/, 7];
                        case 5: return [4 /*yield*/, validateRules(form, rules)];
                        case 6:
                            errors = _a.sent();
                            _a.label = 7;
                        case 7:
                            validateFinished(form, errors);
                            resolve(form.state.error);
                            return [2 /*return*/];
                    }
                });
            }); }).finally(function () {
                form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_END);
                form.setState({ validating: false }, internalLog('set validating -> false', form));
            })];
    });
}); };
export var buildEffects = function (form, listeners, options) {
    if (options === void 0) { options = {}; }
    var stopList = [];
    Keys(listeners).map(function (type) {
        var originCb = listeners[type];
        if (isFn(originCb)) {
            var cb = options.sync ? originCb : buildLazyCallback(originCb);
            if (options.immediate) {
                cb(form);
            }
            stopList.push(form.cycle.add(form, type, cb));
        }
    });
    return function () {
        stopList.forEach(function (stop) { return stop(); });
    };
};
export var buildValidateWithAllChildren = function (form, trigger) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, self, other;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all(__spreadArray([], __read(Object.values(__spreadArray([form], __read(form.allChildren))).map(function (fc) { return fc.validate(trigger); }))))];
            case 1:
                _a = __read.apply(void 0, [_b.sent()]), self = _a[0], other = _a.slice(1);
                // form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_WITH_ALL_CHILDREN_END);
                return [2 /*return*/, __spreadArray([self], __read(other)).filter(function (v) { return v && v.status === 'error'; })];
        }
    });
}); };
export var buildValidateValue = function (form, trigger) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_VALUE_START);
        return [2 /*return*/, form
                .validateWithAllChildren(trigger)
                .then(function (err) {
                if (err.length > 0) {
                    form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_VALUE_FAILED);
                    throw err;
                }
                form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_VALUE_SUCCESS);
                return form.state.value;
            })
                .finally(function () {
                form.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_VALUE_END);
            })];
    });
}); };
var getInitialValueFromParent = function (parentForm, form) {
    if (isValid(parentForm.state.initialValue)) {
        var addressArr = __spreadArray([], __read(form.address.arr));
        addressArr.splice(0, parentForm.address.arr.length);
        return getIn(addressArr, parentForm.state.initialValue);
    }
    if (isRootForm(parentForm)) {
        return undefined;
    }
    else {
        return getInitialValueFromParent(parentForm.parent, form);
    }
};
export var getInitValue = function (form) {
    if (isValid(form.state.initialValue))
        return form.state.initialValue;
    if (isRootForm(form))
        return undefined;
    return getInitialValueFromParent(form.parent, form);
};
export var buildReset = function (form, options) {
    if (options === void 0) { options = {
        validate: false,
    }; }
    var initialValue = clone(getInitValue(form));
    var payload = {
        error: DEFAULT_FORM_STATE.error,
        modified: DEFAULT_FORM_STATE.modified,
    };
    if (isValid(initialValue)) {
        payload.value = initialValue;
    }
    else {
        payload.value = undefined;
    }
    devWarning(isValid(initialValue), 'reset', '未找到 initialValue 所以节点值将被设置为 undefined（error, modified 也将被设置为默认状态）', form);
    form.setState(payload, internalLog('reset', form));
    form.allChildren.forEach(function (fc) {
        fc.setState({ error: DEFAULT_FORM_STATE.error, modified: DEFAULT_FORM_STATE.modified }, internalLog('internal/buildReset', fc));
        fc.publish(LIFE_CYCLE_TYPE.ON_RESET);
    });
    form.publish(LIFE_CYCLE_TYPE.ON_RESET);
    if (options.validate) {
        form.validateWithAllChildren();
    }
    return form;
};
export var buildMakeCommonWatch = function (form) {
    // watch initialValue -> reset value
    watch(function () { return form.initialValue.value; }, function (value) {
        if (!form.state.initialized &&
            isValid(form.state.initialValue) &&
            !isValid(form.state.value)) {
            form.setState({
                value: value,
            }, internalLog('watch initialValue & initialized = false -> setValue', form));
        }
    });
    // when value change, publish cycle event
    // watch(
    //   () => form.value.value,
    //   (v) => {
    //     // if (isValid(v) && !form.state.initialized) {
    //     //   form.setState(
    //     //     {
    //     //       initialized: true,
    //     //     },
    //     //     internalLog('watch value & initialized = false', form),
    //     //   );
    //     //   form.publish(LIFE_CYCLE_TYPE.ON_INITIALIZED);
    //     // }
    //     // lazy 交给 effects 内部处理，这里只管通知就好
    //     form.publish(LIFE_CYCLE_TYPE.ON_VALUE_CHANGE);
    //   },
    //   { deep: true },
    // );
};
export var buildInitialize = function (form, originProps) {
    var props = __assign({}, originProps);
    if (isValid(props.initialValue) &&
        // props 中存在 value
        !Keys(originProps).includes('value') &&
        // form.state 中存在有效 value
        !isValid(form.state.value)) {
        props.value = props.initialValue;
    }
    form.setState(__assign(__assign({}, props), { initialized: true }), internalLog('initialize', form));
    form.publish(LIFE_CYCLE_TYPE.ON_INITIALIZED);
};
export var buildComputedValue = function (form) {
    form.value = computed({
        get: function () { return getIn(__spreadArray(['root'], __read(form.address.arr)), form.root.rootValueContainer.value); },
        set: function (val) {
            setIn(__spreadArray(['root'], __read(form.address.arr)), form.root.rootValueContainer.value, val);
        },
    });
};
export var unshiftRootValueAddressToFormAddress = function (address) { return __spreadArray([ROOT_VALUE_PATH], __read(address.arr)); };
